import { render, staticRenderFns } from "./TagChip.vue?vue&type=template&id=70df532c&"
import script from "./TagChip.vue?vue&type=script&lang=ts&"
export * from "./TagChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports